import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const LanguageFilled = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill={props?.color || '#5FAFFF'}>
      <Path d="M22.343 6.584h-4.055a2.579 2.579 0 0 0-2.57-2.597H6.567a2.572 2.572 0 0 0-2.57 2.569v9.153a2.572 2.572 0 0 0 2.57 2.569h9.153a2.573 2.573 0 0 0 2.569-2.57v-3.93c1.944-.903 3.375-2.486 4.472-4.5a.487.487 0 0 0-.43-.708l.013.014ZM13.72 8.723v4.944l-1.334-.167v-2.125c-.097.014-.194.028-.277.028-.32 0-.64-.111-.903-.292.194.292.291.598.291.903 0 .806-.68 1.542-1.736 1.542-1.18 0-2.152-.93-2.638-2.292l.875-.472c.375.972.93 1.486 1.541 1.486.486 0 .806-.333.806-.708a.775.775 0 0 0-.361-.64c-.292.181-.625.306-.945.362l-.528-1.18c.625-.167 1.473-.473 1.473-.931 0-.194-.125-.361-.43-.361-.376 0-.862.278-1.223.583L7.663 8.39c.514-.486 1.153-.75 1.68-.75.931 0 1.681.723 1.681 1.64 0 .29-.083.555-.194.79.222.098.5.14.764.14s.541-.042.764-.125V8.723h-.959l-.208-1h3.236l.208 1h-.944.028Z" />
      <Path d="M25.552 13.611h-6.597v3.223a2.383 2.383 0 0 1-2.375 2.375h-2.82v.944c-2.139.264-3.514 1.958-4.513 4.333-.181.43.125.903.583.903h3.944A2.596 2.596 0 0 0 16.371 28h9.209a2.602 2.602 0 0 0 2.597-2.597v-9.208a2.602 2.602 0 0 0-2.598-2.598l-.027.014Zm-1.556 10.18a.779.779 0 0 1-.541.21.699.699 0 0 1-.375-.112.674.674 0 0 1-.264-.32l-.403-.902h-2.875l-.403.902a.763.763 0 0 1-.264.32.699.699 0 0 1-.375.111.804.804 0 0 1-.541-.208.63.63 0 0 1-.25-.5c0-.111.027-.223.083-.334l2.347-4.819a.905.905 0 0 1 .347-.375c.153-.083.32-.125.5-.125s.348.042.5.125a.83.83 0 0 1 .348.375l2.347 4.82a.74.74 0 0 1 .083.333.66.66 0 0 1-.236.5h-.028Z" />
      <Path d="M20.093 21.459h1.778l-.889-1.987-.889 1.986Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LanguageFilled
